export default __webpack_public_path__ + "static/media/tds.27fae721.jfif";